/**
 * 下拉
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';
import Select from 'react-select-okjp';

import 'react-datepicker-okjp/src/react-datepicker.css';
import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemSelectDefine extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
  }

  /**
   * 下拉/单选框值变化监听
   * @param newValue 新的值所在的对象
   */
  onSelectChange = (newValue) => {
    const { key, onChange, errorData, formType, extend } =
      this.props.dataSource;
    const val = newValue || ''; // 配置下拉框的情况下 需要的是选中的一个对象的全部的值
    const errorMsg = this.getErrorMsg(newValue.value, errorData);
    const allow = errorMsg.length === 0;
    this.setState({
      value: val,
      errorMsg,
      dataError: errorMsg && errorMsg.length !== 0,
    });
    onChange && onChange(key, formType, newValue, allow, extend);
  };

  /**
   * 渲染下拉类型
   * @returns {*}
   */
  renderFormLineSelect() {
    const { errorMsg, value } = this.state;
    const { list, inputAttr, bottomArea } = this.props.dataSource;
    const { optionComponent, valueComponent, listNullComponent } =
      this.props.dataSource;
    return (
      <div className="form-input-box">
        <span className="form-select">
          {list.length > 0 ? (
            <Select
              {...inputAttr}
              options={list}
              optionComponent={optionComponent}
              name="form-field-name"
              className="select-type"
              value={value}
              valueComponent={valueComponent}
              clearable={false}
              onChange={this.onSelectChange}
            />
          ) : (
            listNullComponent
          )}
        </span>
        <br />
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { dataSource } = this.props;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={this.props.dataSource} />
        {this.renderFormLineSelect()}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemSelectDefine.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.SELECT,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    optionComponent: null, // 选项组件
    valueComponent: null, // 选中组件
    listNullComponent: null, // 没有列表返回时 展示的组件
    filter: (val) => {
      return val;
    },
  },
};
